import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../theme/modern/tokens"

/**
 * Segmented "Classic | Modern" control as it appears in the CLASSIC header.
 *
 * Colours are hard-coded to the legacy Material-UI blue bar (#567cf6) exactly
 * as the prototype's `html[data-ui="classic"] .uimode*` rules specify. This
 * file must NOT read `theme.modern` — it renders under the Classic theme,
 * where those tokens do not exist. The Modern app bar has its own token-styled
 * control in components/modern/ModernAppBar.
 */
export default makeStyles((theme: ModernTheme) => ({
    root: {
        display: "inline-flex",
        alignItems: "center",
        background: "rgba(255,255,255,.16)",
        border: "1px solid rgba(255,255,255,.3)",
        borderRadius: 8,
        padding: 2,
        // Rendered AFTER languages_container, which already owns the
        // `marginLeft: auto` that right-aligns the whole control group. Adding a
        // second auto margin here would split the free space and drag the
        // toggle toward the middle, so this is a fixed gap on purpose.
        marginLeft: 16,
        flex: "0 0 auto",
        [theme.breakpoints.down("xs")]: {
            marginLeft: 8,
        },
    },
    button: {
        font: "inherit",
        fontSize: 11.5,
        fontWeight: 600,
        lineHeight: 1,
        color: "rgba(255,255,255,.85)",
        background: "none",
        border: "none",
        padding: "5px 12px",
        margin: 0,
        borderRadius: 6,
        cursor: "pointer",
        transition: "background .15s, color .15s",
        whiteSpace: "nowrap",
        textTransform: "uppercase",

        "&:hover": {
            color: "#fff",
        },

        [theme.breakpoints.down("sm")]: {
            padding: "5px 9px",
        },
        [theme.breakpoints.down("xs")]: {
            minHeight: 32,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
        },
    },
    button__active: {
        background: "#fff",
        color: "#567cf6",

        "&:hover": {
            color: "#567cf6",
        },
    },
}))
